import axios from "axios";
//

export default axios.create({
   baseURL: "https://esm.qmii.com/qmi/v1",
//  baseURL: "http://localhost:5000/qmi/v1",
});
